export enum MwOverlayPositionX {
    Right,
    Center,
    Left,
  }
